import {UIDeviceController} from '../../shared/scripts/ui_html/UIDeviceController'
import {StorageWrapper} from '../../shared/scripts/StorageWrapper'
import {UIUtilsEjsVariables} from '../../shared/scripts/UIUtilsEjsVariables'

export enum UIMGameMode {
    LANDSCAPE = 0,
    PORTRAIT = 1
}

export class UIMGameOrientationController {
    static readonly deprecatePortraitLandscapeToggleFromTimestamp = 1746037800000 // 1st may 2025
    constructor() {
        UIMGameOrientationController.setPortraitModeForNewPlayers()
        UIMGameOrientationController.disableLandscapeModeForNewPlayers()
        UIMGameOrientationController.disableOrientationToggleForPortraitPlayers()
        StorageWrapper.clearDeprecationStorage()
    }

    private static disableOrientationToggleForPortraitPlayers() {
        const isPortraitPlayer = StorageWrapper.isPortraitGamePlayEnabled()
        if(!isPortraitPlayer) return

        this.hideLandscapeModeToggle()
    }

    private static disableLandscapeModeForNewPlayers() {
        const firstSessionTimestamp = StorageWrapper.getFirstSessionTimestamp()
        if(firstSessionTimestamp == null) return

        const isNewPlayer = firstSessionTimestamp > UIMGameOrientationController.deprecatePortraitLandscapeToggleFromTimestamp
        if(!isNewPlayer) return

        const isIPadPlayer = UIDeviceController.isUserOnTabletApp()
        if(isIPadPlayer) return

        StorageWrapper.setPortraitGamePlayEnabled(true)
        if(!UIUtilsEjsVariables.hideLandscapeForNewPlayers) return
        this.hideLandscapeModeToggle()
    }

    private static hideLandscapeModeToggle() {
        const landscapeToggle = document.getElementById('m-menu-game-mode')
        landscapeToggle?.classList.add('hidden')
    }

    private static setPortraitModeForNewPlayers() {
        const isOnMobileWeb = UIDeviceController.isUserOnMobileWebBrowser()
        const shouldResetOrientation = StorageWrapper.shouldResetGameOrientation()
        const shouldSetPortraitMode = isOnMobileWeb || shouldResetOrientation
        if(!shouldSetPortraitMode) return

        StorageWrapper.setPortraitGamePlayEnabled(true)
        StorageWrapper.setFirstSessionTimestamp(Date.now())
    }
}
